import * as React from "react";
import { useHideNavigation } from "../../hooks/useHideNavigation";
import { ErrorSite } from "../../ui/ErrorSite";

export const NotFoundSite = () => {
    useHideNavigation();

    return <ErrorSite errorCode={404} />;
};
